import { tConv24 } from "utils/dateHelper";
import { TiTick } from "react-icons/ti";
import { FiSearch, FiX } from "react-icons/fi";

export const attendanceApplicationColumns = (action) => [
	{
		id: "actions",
		header: "View",
		accessor: (row) => (
			<div className="text-center">
				<FiSearch style={{ cursor: "pointer" }} className="text-warning" onClick={() => action(row)} />
			</div>
		),
		sortable: false,
		filterable: false,
	},
	{
		id: "teacherName",
		header: "Staff",
		accessor: (row) => row?.staff?.fullName,
		sortable: true,
		filterable: true,
	},
	{
		id: "applicationDate",
		header: "Application Date",
		accessor: (row) => row.attendanceDate,
		sortable: true,
		filterable: true,
	},
	{
		id: "applicationCentre",
		header: "Centre",
		accessor: (row) => row?.centre?.shortName,
		sortable: true,
		filterable: true,
	},
	{
		id: "applicationTime",
		header: "Time",
		accessor: (row) => row?.attendanceTime,
		sortable: true,
		filterable: true,
	},
];
